export const handleError = (fieldName: any, formik: any) => {
  if (formik.touched[fieldName] && Boolean(formik.errors[fieldName])) {
    return `mt-1 border border-red-500 focus:ring-2 focus:outline-none focus:ring-red-500 focus:border-red-500`;
  }
  return `mt-1 border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent`;
};
